export default {
    l_welcome_to_nano: 'Bienvenue sur Nano',
    l_nano_punchline: 'Simply useful URL shortener',
    l_generated_urls: 'URLs générées',
    l_url_address: 'Entrez votre URL',
    l_shorturls: 'URLs courtes',
    l_urls: 'Redirections',
    l_actives: 'Actives',
    l_actions: 'Actions',
    l_no_content_table: 'Pas de redirections pour le moment',
    l_check_url: 'URL invalide',
    l_url_generated_success: 'Redirection créée avec succès',
    l_delete_url: 'Supprimer la redirection ?',
    l_confirm_deletion_of_url: 'Merci de confirmer la suppression de la redirection. Cette action est irréversible.',
    l_yes: 'Confirmer',
    l_cancel: 'Annuler',
    l_unable_to_delete_url: 'Impossible de supprimer l\'URL...',
    l_unable_to_generate_url: 'Impossible de générer l\'URL',
    l_unable_to_update_active: 'Impossible de changer l\'état de la redirection...',
    l_update_ok: 'Redirection mise à jour avec succès !',
    l_success: 'Succès',
    l_error: 'Erreur',
    l_loading_please_wait: 'Redirection...',
    l_redirection_in_progress: 'Redirection en cours... Merci de patienter',
    l_oh_no: 'Oh non !',
    l_no_redirection_error: 'Votre URL n\'est pas valide. Impossible de vous rediriger',
    l_unable_to_copy: 'La copie a échoué',
    l_copy_ok: 'Votre URL a été copiée dans le presse-papier',
    l_here_is_the_qrcode: 'Voici le QRCode correspondant au lien générée',
    l_ok: 'Ok',
};
